module.exports = __webpack_public_path__ + "static/2front-design-1-0d3c6fe165887d7f4bc4f432b8647451.png";